<div *ngIf="viewModel$ | async as vm" class="graph-container is-relative">

  <lib-chart
    [class.blur]="vm.loading"
    [config]="vm.config"
    [apiScale]="vm.apiScale"
    [xMin]="vm.timeRange.dateBegin.valueOf()"
    [xMax]="vm.timeRange.dateEnd.valueOf()"
    [enablePan]="false"
    [enableSwipe]="false">
  </lib-chart>

  <app-no-data-icon *ngIf="!vm.loading && hasNoData"></app-no-data-icon>

  <app-graph-tooltip></app-graph-tooltip>

  <div *ngIf="vm.loading" class="is-overlay is-flex is-justify-center is-align-center text-32">
    <div class="is-loading-overlay"></div>
  </div>

</div>